import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { LandingPage } from './pages/LandingPage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { PlatformLayout } from './pages/PlatformLayout';
import { AssistantPage } from './pages/AssistantPage';
import { JobsPage } from './pages/JobsPage';
import { AdminPage } from './pages/AdminPage';
import { KnowledgePage } from './pages/KnowledgePage';
import { VerificationPage } from './pages/VerificationPage';
import { PublicVerificationPage } from './pages/PublicVerificationPage';
import { PlanProcessingPage } from './pages/PlanProcessingPage';
import { ResultsPage } from './pages/ResultsPage';
import { GeneralStudioPage } from './pages/GeneralStudioPage';
import { LocalArchitectureStudioPage } from './pages/LocalArchitectureStudioPage';

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <main className="grid min-h-screen place-items-center bg-sand text-ink">
        <div className="animate-pulse text-lg font-bold">جارٍ تحميل منصة Details AI…</div>
      </main>
    );
  }
  return user ? children : <Navigate to="/admin/login" replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/verify/:token" element={<PublicVerificationPage />} />
      <Route
        path="/app"
        element={
          <Protected>
            <PlatformLayout />
          </Protected>
        }
      >
        <Route index element={<AssistantPage />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="knowledge" element={<KnowledgePage />} />
        <Route path="verification" element={<VerificationPage />} />
        <Route path="results" element={<ResultsPage />} />
        <Route path="studio" element={<GeneralStudioPage />} />
        <Route path="architecture" element={<LocalArchitectureStudioPage />} />
        <Route path="plans" element={<PlanProcessingPage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
